import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = 0;

export const pageStateSlice = createSlice({
  name: 'pageState',
  initialState,
  reducers: {
    setPageState: (state, { payload: { page } }) => {
      return page;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPageState } = pageStateSlice.actions;

export const getPageState = (state: RootState) => state.pageState;

export default pageStateSlice.reducer;
